
const digest = 'd89256ebf686951f46e430d8d1d30cfffa6f983eb916c69447103ca1571be6cc';
const classes = {"wrapper":"_wrapper_1a9ij_1"};
const css = `._wrapper_1a9ij_1 {
  display: contents;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  